/**
 * Global design system: icon card for value props, process steps, and similar sections.
 * Single style across the app (e.g. Team Augmentation, Our Approach).
 * Parent must have class "group" for hover styles.
 * iconHighlight: use highlight (neon green) for icon color.
 * dark: for use on dark (navy) backgrounds – light icon, hover to highlight.
 */
export function IconCard({ Icon, className = '', iconHighlight = false, dark = false }) {
  if (dark) {
    return (
      <div
        className={`w-14 h-14 rounded-xl flex items-center justify-center transition-all duration-300 bg-white/10 group-hover:bg-highlight group-hover:scale-105 ${className}`.trim()}
        aria-hidden
      >
        <Icon className="w-7 h-7 transition-colors duration-300 text-white group-hover:text-navy" />
      </div>
    );
  }
  return (
    <div
      className={`w-14 h-14 rounded-xl flex items-center justify-center transition-all duration-300 bg-[#EFF6FF] group-hover:bg-navy group-hover:scale-105 ${className}`.trim()}
      aria-hidden
    >
      <Icon
        className={`w-7 h-7 transition-colors duration-300 ${iconHighlight ? 'text-highlight group-hover:text-white' : 'text-navy group-hover:text-white'}`}
      />
    </div>
  );
}
